import React from 'react'
import ExpiredMedicine from '../../medicine/components/expiredMedicine'

export default () => {
    return <div className='containerChilderWrapper'>
        <ExpiredMedicine isExpired={true} />
    </div>
}
